import React, { useEffect, useState, useRef } from "react";
import { connect, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { useParams } from "react-router-dom";
import {
  reduxForm,
  Field,
  getFormValues,
  setSubmitFailed,
  stopSubmit,
  untouch,
} from "redux-form";
import moment from "moment";
import _ from "lodash";
import {
  ChevronUpIcon,
  ChevronDownIcon,
  EyeIcon,
  EyeSlashIcon,
} from "@heroicons/react/24/solid";
import { XMarkIcon, InformationCircleIcon } from "@heroicons/react/24/outline";
import QRCode from "react-qr-code";
import {
  validateAssignedEmail,
  ticketAssignReassign,
  fetchSingleOrder,
} from "@ticketsaction";
import { _uploadDynamicFormsFiles } from "@registrationaction";
import {
  renderFieldText,
  RenderFieldPhone,
  renderHiddenFieldText,
} from "@basecomponent";
import {
  classNames,
  validateEmail,
  validateUrl,
  checkDateFormatYMD,
  validatePhoneNumbers,
  validateEmailDomain,
  sessionRSVPAllowed,
} from "@utilscommon";
import { WEB_PORTAL_URL, SITE_URL, WEB_FOLDER } from "@constant";
import { DATE_FORMAT, DISPLAY_BROWSER_DATE_FORMAT } from "@datehandle";
import SectionList from "@formsection";
import { handleShowHide } from "@fieldshowhide";
import SessionRSVP from "@rsvpsessionsfield";
import LocaleStrings from "@language";
import GooglePlay from "../../../../assets/image/GooglePlay.png";
import AppStore from "../../../../assets/image/AppStore.png";

let allConditionalFields = [];
let sectionWiseArray = [];

const TicketAssign = (props) => {
  const { ordernumber } = useParams();
  const dispatch = useDispatch();
  const {
    // Parent
    assign,
    form,

    // Own
    session,
    eventData,
    eventSettingsData,
    eventCustomSettings,
    orderData,
    eventUserCategories,
    countryList,
    handleSubmit,
    pristine,
    invalid,
    submitting,
    autofill,
    formValues,
  } = props;
  const [loading, setLoading] = useState(false);
  const [openContent, setContentOpen] = useState(false);
  const [orderErrorMessage, setOrderErrorMessage] = useState("");
  const [displayPasscode, setDisplayPasscode] = useState(false);
  const [displayBox, setDisplayBox] = useState("");
  const [lastFieldUpdated, setLastFieldUpdated] = useState("");
  const alertRef = useRef(null);
  const action = assign?.action;
  const ticketGenre = assign?.ticketgenre;
  const ticketTag = assign?.tickettag;
  const ticketColor = assign?.colorcode;
  const usercategory = assign?.usercategory;
  const assignformdisplay = assign?.assignformdisplay;
  const ticketcode = assign?.ticketcode ?? assign?.id;
  const position = assign?.position;
  const allowPhoneSignup = assign?.allowphonelogin ?? false; // Dynamic form phone login
  const emailOptional = assign?.emailoptional ?? false; // Dynamic form email is optional setting, Validate email field as per setting
  const sessionRSVPPage = assign?.rsvpsessions ?? []; // Ticket associated RSVP sessions
  const rsvpsessions = formValues?.rsvpsessions ?? []; // Marked session as RSVP
  let ticketSessionSettings = {};
  if (sessionRSVPPage?.length > 0) {
    let ticket = assign;
    // Check for ticket session rsvp related setting
    ticketSessionSettings = sessionRSVPAllowed(
      ticket,
      eventData?.eventtimezone
    );
  }
  // console.log({ ticketSessionSettings, formValues });
  const allowRSVP = ticketSessionSettings?.allowrsvp ?? true; // Session RSVP restriction
  const maxSessionRSVP = ticketSessionSettings?.maxsessionrsvp ?? ""; // Session RSVP max limit
  let allowReassign = eventSettingsData?.data?.ticketreassign; // Check if ticket reassign option available or not
  let rsvpMandatory = eventCustomSettings?.rsvp_mandatory ?? false;
  let hideAssignDetails = eventCustomSettings?.hide_applinks_qr ?? false;
  if (!assign?.email) {
    hideAssignDetails = false;
  }

  let formArray = [];
  if (ticketGenre !== "addon" && eventUserCategories?.data) {
    let matchCat = _.filter(eventUserCategories?.data, (obj) => {
      return obj.id === usercategory;
    });
    formArray = matchCat?.length > 0 ? JSON.parse(matchCat?.[0]?.formjson) : [];
  }
  let checkPhone = _.filter(formArray, (obj) => obj.name === "phonenumber");
  let countrycode = checkPhone?.[0]?.defaultvalue ?? ""; // default country code checking
  let dropdowndisabled =
    countrycode && countrycode !== "" ? checkPhone?.[0]?.isrestricted : false; // disabled country dropdownlist

  // Get all has conditional fields
  let conditionalFields = _.filter(
    formArray,
    (obj) =>
      (obj.key === "radiobuttons" ||
        obj.key === "checkboxes" ||
        obj.key === "dropdown") &&
      obj.hasCondition
  );
  allConditionalFields = conditionalFields;

  // Create section wise fields
  let fieldsArr = JSON.parse(JSON.stringify(formArray));
  let currentSection = "";
  let sectionWiseArr = [];
  _.map(fieldsArr, (o) => {
    let key = o.key;

    if (key === "section") {
      currentSection = o?.name;
      o.elements = [];
      sectionWiseArr.push(o);
    } else {
      let index = _.findIndex(sectionWiseArr, (e) => {
        return e?.name === currentSection;
      });

      if (index >= 0) {
        sectionWiseArr[index].elements.push(o);
      }
    }
  });
  sectionWiseArray = sectionWiseArr;

  useEffect(() => {
    if (assign?.action === "reassign") {
      setContentOpen(true);
      setDisplayBox("view");
    }
  }, [assign]);
  // console.log("assign :- ", assign);

  const onSubmitForm = (data) => {
    // console.log("data :- ", data);
    let ticketGenre = assign?.ticketgenre;
    let ticketid = assign?.ticketid;
    let mainFields = ["email", "firstname", "lastname", "interest"];
    if (ticketGenre === "addon") {
      mainFields = ["email"];
    }
    if (allowPhoneSignup) {
      mainFields.push("phone");
    }
    let values = {};
    // Creating values as required to store in separate column
    _.map(mainFields, (main) => {
      if (data.hasOwnProperty(main)) {
        if (main === "interest") {
          values[main] = _.uniqBy(data[main]); // Its comes in array so by any chance if any interest id is duplicate, here we are removing.
        } else {
          values[main] = data[main];
        }
      } else {
        if (main === "interest") {
          values.interest = [];
        } else {
          values[main] = "";
        }
      }
    });

    values.eventid = assign?.eventid;
    if (assign?.action === "assign") {
      values.orderid = orderData?.data?.id;
      values.position = assign?.position;
      values.ticketid = ticketid;
      if (ticketGenre === "addon") {
        values.type = "assignaddon";
      } else {
        values.type = "assignattendee";
      }
    } else {
      values.id = assign?.assignedid;
      if (ticketGenre === "addon") {
        values.type = "reassignaddon";
      } else {
        values.type = "reassignattendee";
      }
    }

    if (data?.rsvpsessions && data?.rsvpsessions?.length > 0) {
      values.rsvpsessions = data?.rsvpsessions ?? [];
    }

    let formData = [];
    let otherFilesData = [];
    if (ticketGenre !== "addon") {
      _.map(formArray, (form) => {
        let formKey = form?.key;
        let name = form?.name;
        let isReadOnly = form?.isreadonly ?? false;
        let isHidden = form?.hidden ?? false;

        if (
          formKey !== "label" &&
          formKey !== "hyperlink" &&
          formKey !== "paragraph" &&
          formKey !== "section"
        ) {
          if (data.hasOwnProperty(name)) {
            if (formKey === "datepicker") {
              let date = "";
              if (data[name] && data[name] !== "") {
                if (form?.pickertype === "range") {
                  data[name] = _.isString(data[name])
                    ? data[name].split(" - ")
                    : [];
                  date = data[name]
                    ?.map((d) => {
                      if (typeof d === "string" && checkDateFormatYMD(d)) {
                        return moment(new Date(Date.parse(d)))?.format(
                          DATE_FORMAT
                        );
                      } else {
                        return moment(d, DISPLAY_BROWSER_DATE_FORMAT)?.format(
                          DATE_FORMAT
                        );
                      }
                    })
                    .filter((d) => moment(d)?.isValid()); // Filter out invalid dates
                  date = date?.join(" - ");
                } else {
                  if (data[name] && typeof data[name] === "string") {
                    if (checkDateFormatYMD(data[name])) {
                      let dateParse = new Date(Date.parse(data[name]));
                      date = moment(dateParse).format(DATE_FORMAT);
                    } else {
                      date = moment(
                        data[name],
                        DISPLAY_BROWSER_DATE_FORMAT
                      ).format(DATE_FORMAT);
                    }
                    if (!moment(date).isValid()) {
                      date = "";
                    }
                  } else {
                    date = moment(data[name]).format(DATE_FORMAT);
                  }
                }
              }

              form.value = !isReadOnly && !isHidden ? date : "";
            } else if (formKey === "dropdown") {
              let checkType = typeof data[name];
              let val = "";
              if (checkType === "object") {
                val = data?.[name]?.value ?? "";
              } else {
                val = data?.[name] ?? "";
              }
              form.value = !isReadOnly && !isHidden ? val : "";
            } else if (formKey === "dynamicfield" && name === "interest") {
              // No value need to store here.
            } else {
              form.value = !isReadOnly && !isHidden ? data[name] : "";
              if (formKey === "checkboxes" || formKey === "file") {
                form.value = !isReadOnly && !isHidden ? data[name] : [];
              }
            }
          } else {
            if (formKey === "checkboxes" || formKey === "file") {
              form.value = [];
            } else if (formKey === "dynamicfield" && name === "interest") {
              // No value need to store here.
            } else {
              form.value = "";
            }
          }
        }

        formData.push(form);
      });
      // console.log("formData :- ", formData);

      values.responses = JSON.stringify(formData);

      otherFilesData = _.filter(formData, (form) => {
        return form?.key === "file" && form?.value?.length > 0;
      });
    }
    // console.log("final value before file upload :- ", values);
    // return;

    // Upload files if any in checkout form
    let promiseArray = [];
    if (otherFilesData?.length > 0) {
      promiseArray.push(
        new Promise((resolve, reject) => {
          _uploadDynamicFormsFiles(
            session,
            eventData?.eventid,
            otherFilesData,
            dispatch,
            (filesArray) => {
              // console.log("filesArray :- ", filesArray);
              _.map(formData, (obj) => {
                let check = _.filter(filesArray, function (file) {
                  return file.name === obj.name;
                });

                if (check?.length > 0) {
                  obj.value = check[0].value;
                }
              });
              // console.log("new formData :- ", formData);

              values = {
                ...values,
                responses: JSON.stringify(formData),
              };

              resolve();
            }
          );
        })
      );
    }

    setLoading(true);
    Promise.all(promiseArray).then(() => {
      // console.log("final value :- ", values);
      props.ticketAssignReassign(session, values, (response) => {
        // console.log("api response :- ", response);
        if (response?.success === 1) {
          let data = {
            ordernumber: ordernumber,
            eventid: orderData?.data?.eventid,
          };
          props.fetchSingleOrder(session, data, () => {
            setLoading(false);
            setContentOpen(false);
            setDisplayBox("");
          });
        } else if (response?.success === 2) {
          setLoading(false);
          if (response?.data?.code === "eventid_required") {
            setOrderErrorMessage(LocaleStrings.kEventidRequiredText);
          } else if (response?.data?.code === "orderid_required") {
            setOrderErrorMessage(LocaleStrings.kOrderidRequiredText);
          } else if (response?.data?.code === "firstname_required") {
            setOrderErrorMessage(LocaleStrings.kFirstNameRequiredText);
          } else if (response?.data?.code === "lastname_required") {
            setOrderErrorMessage(LocaleStrings.kLastNameRequiredText);
          } else if (response?.data?.code === "email_required") {
            setOrderErrorMessage(LocaleStrings.kEmailRequiredText);
          } else if (response?.data?.code === "invalid_email") {
            setOrderErrorMessage(LocaleStrings.kInvalidEmail);
          } else if (response?.data?.code === "email_or_phone_required") {
            setOrderErrorMessage(LocaleStrings.kRegistrationWithRequired);
          } else if (response?.data?.code === "ticketid_required") {
            setOrderErrorMessage(LocaleStrings.kTicketidRequiredText);
          } else if (response?.data?.code === "position_required") {
            setOrderErrorMessage(LocaleStrings.kPositionRequiredText);
          } else if (response?.data?.code === "id_required") {
            setOrderErrorMessage(LocaleStrings.kAssignedAttendeeIdRequiredText);
          } else if (response?.data?.code === "invalid_attendee_id") {
            setOrderErrorMessage(
              LocaleStrings.kInvalidOldAssignedAttendeeIdText
            );
          } else if (response?.data?.code === "invalid_order_item") {
            setOrderErrorMessage(LocaleStrings.kInvalidOrderItemText);
          } else if (response?.data?.code === "email_domain_not_allowed") {
            setOrderErrorMessage(
              _.replace(
                LocaleStrings.kInvalidEmailDomainText,
                "###DOMAIN###",
                response?.data?.resource?.domain
              )
            );
          } else if (response?.data?.code === "user_already_registered") {
            setOrderErrorMessage(LocaleStrings.kUserAlreadyRegisteredText);
          } else if (response?.data?.code === "ticket_already_assigned") {
            setOrderErrorMessage(
              _.replace(
                LocaleStrings.kTicketAlreadyAssignedText,
                "###USER###",
                response?.data?.resource?.user
              )
            );
          } else if (response?.data?.code === "all_purchased_ticket_assigned") {
            setOrderErrorMessage(
              LocaleStrings.kTicketAllPurchasedQtyAssignedText
            );
          } else if (response?.data?.code === "ticket_reassign_not_allowed") {
            setOrderErrorMessage(LocaleStrings.kTicketReassignNotAllowedText);
          } else if (
            response?.data?.code === "user_have_other_access_permission"
          ) {
            setOrderErrorMessage(
              LocaleStrings.kUserHaveOtherAccessPermissionText
            );
          } else if (
            response?.data?.code === "user_have_same_ticket_permission"
          ) {
            setOrderErrorMessage(
              LocaleStrings.kUserAlreadyHaveCurrentTicketAccessText
            );
          } else if (response?.data?.code === "appuser_not_updated") {
            setOrderErrorMessage(
              LocaleStrings.kUserNotUpdatedWithCurrentTicketText
            );
          } else if (response?.data?.code === "appuser_not_created") {
            setOrderErrorMessage(
              LocaleStrings.kUserNotCreatedWithCurrentTicketText
            );
          } else if (response?.data?.code === "user_created_but_not_assigned") {
            setOrderErrorMessage(
              LocaleStrings.kUserCreatedButNotAssignedWithTicketText
            );
          } else if (response?.data?.code === "not_addon_ticket") {
            setOrderErrorMessage(LocaleStrings.kNotAddonTicketText);
          } else if (
            response?.data?.code === "user_not_associated_with_event"
          ) {
            setOrderErrorMessage(LocaleStrings.kThisUserNotRegistered);
          } else if (response?.data?.code === "user_not_assigned") {
            setOrderErrorMessage(LocaleStrings.kAddonTickNotAssignedText);
          } else if (response?.data?.code === "same_email") {
            setOrderErrorMessage(LocaleStrings.kReassignSameEmailText);
          } else if (response?.data?.code === "session_seat_full") {
            setOrderErrorMessage(
              _.replace(
                LocaleStrings.kSessionSeatFullText,
                "#sessions",
                response?.data?.resource?.sessions
              )
            );
          } else if (
            response?.data?.code ===
            "same_track_multiple_session_rsvp_not_allowed"
          ) {
            setOrderErrorMessage(
              _.replace(
                LocaleStrings.kSameTrackSessionRSVPNotAllowedText,
                "#sessions",
                response?.data?.resource?.sessions
              )
            );
          } else if (
            response?.data?.code === "common_time_session_rsvp_not_allowed"
          ) {
            setOrderErrorMessage(
              _.replace(
                LocaleStrings.kCommonTimeSessionRSVPNotAllowedText,
                "#sessions",
                response?.data?.resource?.sessions
              )
            );
          } else if (response?.data?.code === "session_rsvp_time_invalid") {
            setOrderErrorMessage(
              ticketSessionSettings?.allowstatus === "not_started"
                ? LocaleStrings.kRSVPSessionNotStartedForCurrentTicketText.replace(
                    "###STARTTIME###",
                    ticketSessionSettings?.starttime
                  )
                : LocaleStrings.kRSVPSessionEndedForCurrentTicketText.replace(
                    "###ENDTIME###",
                    ticketSessionSettings?.endtime
                  )
            );
          } else if (
            response?.data?.code === "max_session_rsvp_limit_reached"
          ) {
            setOrderErrorMessage(
              LocaleStrings.kRSVPSessionForCurrentTicketMaxLimitText.replaceAll(
                "###MAXLIMIT###",
                response?.data?.resource?.maxsessionrsvp
              )
            );
          } else {
            setOrderErrorMessage(LocaleStrings.kSomethingWentWrongMsg);
          }
        } else {
          setLoading(false);
          setOrderErrorMessage(LocaleStrings.kSomethingWentWrongMsg);
        }
      });
    });
  };

  const handleEmailCheck = (e) => {
    let email = e.target.value;

    if (validateEmail(email)) {
      let values = {
        ticketid: assign?.ticketid,
        eventid: eventData?.eventid,
        email: email,
      };
      validateRegistrationId(values);
    }
  };

  const handlePhoneCheck = (e) => {
    let phone = formValues.phone;

    if (validatePhoneNumbers(phone)) {
      let values = {
        ticketid: assign?.ticketid,
        eventid: eventData?.eventid,
        phone: phone,
      };
      validateRegistrationId(values);
    }
  };

  const validateRegistrationId = (payload) => {
    props.validateAssignedEmail(session, payload, (response) => {
      // console.log("response :- ", response);
      if (response?.success === 2) {
        let message = "";
        if (response?.data?.code === "eventid_required") {
          message = LocaleStrings.kEventidRequiredText;
        } else if (response?.data?.code === "email_required") {
          message = LocaleStrings.kBuyerEmailRequiredText;
        } else if (response?.data?.code === "ticketid_required") {
          message = LocaleStrings.kTicketidRequiredText;
        } else if (response?.data?.code === "invalid_email") {
          message = LocaleStrings.kInvalidEmail;
        } else if (response?.data?.code === "invalid_phonenumber") {
          message = LocaleStrings.kInvalidPhoneText;
        } else if (response?.data?.code === "invalid_ticketid") {
          message = LocaleStrings.kInvalidTicketText;
        } else if (response?.data?.code === "email_or_phone_required") {
          message = LocaleStrings.kRegistrationWithRequired;
        } else if (response?.data?.code === "user_not_associated_with_event") {
          message =
            response?.data?.resource?.reg_type === "phone"
              ? LocaleStrings.kThisPhoneNotRegistered
              : LocaleStrings.kThisEmailNotRegistered;
        } else if (response?.data?.code === "email_domain_not_allowed") {
          message = _.replace(
            LocaleStrings.kInvalidEmailDomainText,
            "###DOMAIN###",
            response?.data?.resource?.domain
          );
        } else if (response?.data?.code === "user_already_registered") {
          message =
            response?.data?.resource?.reg_type === "phone"
              ? LocaleStrings.kPhoneAlreadyRegisteredText
              : LocaleStrings.kEmailAlreadyRegisteredText;
        } else if (
          response?.data?.code === "user_have_other_access_permission"
        ) {
          message = LocaleStrings.kUserHaveOtherAccessPermissionText;
        } else if (
          response?.data?.code === "user_have_same_ticket_permission"
        ) {
          message = LocaleStrings.kUserAlreadyHaveCurrentTicketAccessText;
        } else {
          message = LocaleStrings.kSomethingWentWrongMsg;
        }
        if (payload?.phone) {
          dispatch(setSubmitFailed(`${form}`, "phone"));
          dispatch(stopSubmit(`${form}`, { phone: message }));
        } else {
          dispatch(setSubmitFailed(`${form}`, "email"));
          dispatch(stopSubmit(`${form}`, { email: message }));
        }
      } else {
        dispatch(stopSubmit(`${form}`, {}));
        if (payload?.phone) {
          // dispatch(untouch(`${form}`, "phone"));
        } else {
          // dispatch(untouch(`${form}`, "email"));
        }
      }
    });
  };

  const closeAlert = () => {
    alertRef.current.className = "hidden";
    setOrderErrorMessage("");
  };

  const handleAccordion = () => {
    if (openContent) {
      setContentOpen(false);
      setDisplayBox("");
    } else {
      setContentOpen(true);
      setDisplayBox(assign?.action === "reassign" ? "view" : "form");
    }
  };

  const handleViewTicket = (e) => {
    // console.log("here...... view");
    e.preventDefault();
    e.stopPropagation();

    if (openContent) {
      if (displayBox === "form") {
        setDisplayBox("view");
      } else {
        setDisplayBox("");
        setContentOpen(false);
      }
    } else {
      setContentOpen(true);
      setDisplayBox("view");
    }
  };

  const handleReassign = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (openContent) {
      if (displayBox === "view") {
        setDisplayBox("form");
      } else {
        setDisplayBox("");
        setContentOpen(false);
      }
    } else {
      setContentOpen(true);
      setDisplayBox("form");
    }
  };

  const handleApp = (app) => {
    if (app === "ios") {
      window.open(eventData?.iosappstorelink, "_blank");
    } else {
      window.open(eventData?.androidplaystorelink, "_blank");
    }
  };

  const openWebPortel = () => {
    if (assign?.regtype === "nologinid") {
      return;
    }
    let eventSeoCode = eventData?.seocode;
    let hostname = window.location.hostname;

    let portal = WEB_PORTAL_URL.replace("{seocode}", eventSeoCode);
    if (!hostname.includes(SITE_URL)) {
      if (eventSeoCode.charAt(eventSeoCode.length - 1) === "/") {
        eventSeoCode = eventSeoCode.slice(0, -1);
      }
      portal = `https://${eventSeoCode}${WEB_FOLDER}`;
    }

    let url = `${portal}/overview`;
    if (
      eventSettingsData?.data?.autologin === true &&
      assign?.regvalue &&
      assign?.passcode
    ) {
      url = `${portal}/autologin?email=${assign?.regvalue}&passcode=${assign?.passcode}`;
    }
    // console.log(assign, eventSettingsData, url);
    window.open(`${url}`, "_blank");
  };

  const handlePasscodeDisplay = (action) => {
    setDisplayPasscode(action === "display" ? true : false);
  };

  const updatedLastField = (field) => {
    let name = field.name;
    setLastFieldUpdated(name);
  };

  const renderSessionRSVPValidation = () => {
    let displaySessionRSVPInfo =
      !allowRSVP ||
      (maxSessionRSVP !== "" &&
        rsvpsessions.length >= parseInt(maxSessionRSVP));

    let warningText = "";
    if (!allowRSVP) {
      warningText =
        ticketSessionSettings?.allowstatus === "not_started"
          ? LocaleStrings.kRSVPSessionNotStartedForCurrentTicketText.replace(
              "###STARTTIME###",
              `<b>${ticketSessionSettings?.starttime}</b>`
            )
          : LocaleStrings.kRSVPSessionEndedForCurrentTicketText.replace(
              "###ENDTIME###",
              `<b>${ticketSessionSettings?.endtime}</b>`
            );
    } else if (
      maxSessionRSVP !== "" &&
      rsvpsessions.length >= parseInt(maxSessionRSVP)
    ) {
      warningText =
        LocaleStrings.kRSVPSessionForCurrentTicketMaxLimitText.replace(
          "###MAXLIMIT###",
          `<b>${maxSessionRSVP}</b>`
        );
    }

    return (
      <>
        {displaySessionRSVPInfo ? (
          <div className="flex gap-2">
            <InformationCircleIcon className="custom-text-theme-sm-medium w-5 h-5" />
            <div
              className="custom-text-theme-sm-medium"
              dangerouslySetInnerHTML={{ __html: warningText }}
            />
          </div>
        ) : (
          <></>
        )}
      </>
    );
  };

  const renderFixedFields = (genre = "", display = "") => {
    // console.log({ genre, display });

    return (
      <>
        {genre === "general" ? (
          <>
            {assignformdisplay === "long" || sessionRSVPPage?.length > 0 ? (
              <>
                <div className="rounded-xl border border-default">
                  <div className="rounded-t-xl border-b border-default bg-default px-6 py-4">
                    <div className="custom-text-primary-md-medium">
                      {LocaleStrings.kProfileSectionTitle}
                    </div>
                    <div className="custom-text-secondary-sm-medium">
                      {LocaleStrings.kProfileSectionDesc}
                    </div>
                  </div>
                  <dl className="base-form bg-white rounded-b-xl px-6 py-4">
                    <div className="md:grid grid-cols-4 md:space-x-6 space-y-2 2xs:space-y-4 md:space-y-0">
                      <div className="col-span-2">
                        <Field
                          name={`firstname`}
                          label={LocaleStrings.kFirstName}
                          placeholder={LocaleStrings.kPlaceholderFirstName}
                          type="text"
                          component={renderFieldText}
                          mandatory={true}
                        />
                      </div>
                      <div className="col-span-2">
                        <Field
                          name={`lastname`}
                          label={LocaleStrings.kLastName}
                          placeholder={LocaleStrings.kEnterLastName}
                          type="text"
                          component={renderFieldText}
                          mandatory={true}
                        />
                      </div>
                    </div>
                    <div
                      className={classNames(
                        allowPhoneSignup
                          ? "md:grid grid-cols-11 md:space-x-6 space-y-2 2xs:space-y-4 md:space-y-0"
                          : ""
                      )}
                    >
                      <div className="md:col-span-5">
                        <Field
                          name={`email`}
                          label={LocaleStrings.kEmail}
                          placeholder={LocaleStrings.kEnterEmailAddress}
                          type="text"
                          component={renderFieldText}
                          mandatory={!emailOptional}
                          onBlur={handleEmailCheck}
                        />
                      </div>
                      {allowPhoneSignup ? (
                        <>
                          <div className="md:col-span-1 md:pt-11 text-center">
                            {LocaleStrings.kOr}
                          </div>
                          <div className="md:col-span-5">
                            <Field
                              name={"phone"}
                              label={LocaleStrings.kPhoneNumber}
                              type={"number"}
                              component={RenderFieldPhone}
                              mandatory={true}
                              countrycode={countrycode}
                              countryList={countryList}
                              isrestricted={dropdowndisabled}
                              onBlur={handlePhoneCheck}
                            />
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                    {allowPhoneSignup ? (
                      <Field
                        name="registerwith"
                        type="text"
                        component={renderHiddenFieldText}
                      />
                    ) : (
                      ""
                    )}
                  </dl>
                </div>

                {assignformdisplay === "long" ? (
                  <>{renderSinglePageSections()}</>
                ) : (
                  ""
                )}

                {sessionRSVPPage?.length > 0 ? (
                  <div className="rounded-xl border border-default">
                    <div className="rounded-t-xl border-b border-default bg-default px-6 py-4">
                      <div className="custom-text-primary-md-medium">
                        {LocaleStrings.kSessionRSVPSectionTitle}
                        {rsvpMandatory && allowRSVP && (
                          <span className="label-mandatory">*</span>
                        )}
                      </div>
                      <div className="custom-text-secondary-sm-medium">
                        {LocaleStrings.kSessionRSVPSectionDesc}
                      </div>
                    </div>
                    <dl className="base-form bg-white rounded-b-xl px-6 py-4">
                      {renderSessionRSVPValidation()}
                      <SessionRSVP
                        source="ticket"
                        ticketSessionSettings={ticketSessionSettings}
                        autofill={autofill}
                        formValues={formValues}
                        RSVPSessionsData={sessionRSVPPage}
                        eventSettingsData={eventSettingsData?.data}
                      />
                    </dl>
                  </div>
                ) : (
                  ""
                )}
              </>
            ) : (
              <>
                <div className="md:grid grid-cols-4 md:space-x-6 space-y-2 2xs:space-y-4 md:space-y-0">
                  <div className="col-span-2">
                    <Field
                      name={`firstname`}
                      label={LocaleStrings.kFirstName}
                      placeholder={LocaleStrings.kPlaceholderFirstName}
                      type="text"
                      component={renderFieldText}
                      mandatory={true}
                    />
                  </div>
                  <div className="col-span-2">
                    <Field
                      name={`lastname`}
                      label={LocaleStrings.kLastName}
                      placeholder={LocaleStrings.kEnterLastName}
                      type="text"
                      component={renderFieldText}
                      mandatory={true}
                    />
                  </div>
                </div>
                <div
                  className={classNames(
                    allowPhoneSignup
                      ? "md:grid grid-cols-11 md:space-x-6 space-y-2 2xs:space-y-4 md:space-y-0"
                      : ""
                  )}
                >
                  <div className="md:col-span-5">
                    <Field
                      name={`email`}
                      label={LocaleStrings.kEmail}
                      placeholder={LocaleStrings.kEnterEmailAddress}
                      type="text"
                      component={renderFieldText}
                      mandatory={!emailOptional}
                      onBlur={handleEmailCheck}
                    />
                  </div>
                  {allowPhoneSignup ? (
                    <>
                      <div className="md:col-span-1 md:pt-11 text-center">
                        {LocaleStrings.kOr}
                      </div>
                      <div className="md:col-span-5">
                        <Field
                          name={"phone"}
                          label={LocaleStrings.kPhoneNumber}
                          type={"number"}
                          component={RenderFieldPhone}
                          mandatory={true}
                          countrycode={countrycode}
                          countryList={countryList}
                          isrestricted={dropdowndisabled}
                          onBlur={handlePhoneCheck}
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
                {allowPhoneSignup ? (
                  <Field
                    name="registerwith"
                    type="text"
                    component={renderHiddenFieldText}
                  />
                ) : (
                  ""
                )}
              </>
            )}
          </>
        ) : genre === "addon" ? (
          <>
            {sessionRSVPPage?.length > 0 ? (
              <>
                <div className="base-form">
                  <div className="rounded-xl border border-default">
                    <div className="rounded-t-xl border-b border-default bg-default px-6 py-4">
                      <div className="custom-text-primary-md-medium">
                        {LocaleStrings.kAddonTicketSectionTitle}
                      </div>
                      <div className="custom-text-secondary-sm-medium">
                        {LocaleStrings.kAddonTicketSectionDesc}
                      </div>
                    </div>
                    <dl className="base-form bg-white rounded-b-xl px-6 py-4">
                      <div
                        className={classNames(
                          allowPhoneSignup
                            ? "md:grid grid-cols-11 md:space-x-6 space-y-2 2xs:space-y-4 md:space-y-0"
                            : ""
                        )}
                      >
                        <div className="md:col-span-5">
                          <Field
                            name={`email`}
                            label={LocaleStrings.kEmail}
                            placeholder={LocaleStrings.kEnterEmailAddress}
                            type="text"
                            component={renderFieldText}
                            mandatory={true}
                            onBlur={handleEmailCheck}
                          />
                          {allowPhoneSignup ? (
                            <>
                              <div className="md:col-span-1 md:pt-11 text-center">
                                {LocaleStrings.kOr}
                              </div>
                              <div className="md:col-span-5">
                                <Field
                                  name={"phone"}
                                  label={LocaleStrings.kPhoneNumber}
                                  type={"number"}
                                  component={RenderFieldPhone}
                                  mandatory={true}
                                  countrycode={countrycode}
                                  countryList={countryList}
                                  isrestricted={dropdowndisabled}
                                  onBlur={handlePhoneCheck}
                                />
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      {allowPhoneSignup ? (
                        <Field
                          name="registerwith"
                          type="text"
                          component={renderHiddenFieldText}
                        />
                      ) : (
                        ""
                      )}
                    </dl>
                  </div>

                  <div className="rounded-xl border border-default">
                    <div className="rounded-t-xl border-b border-default bg-default px-6 py-4">
                      <div className="custom-text-primary-md-medium">
                        {LocaleStrings.kSessionRSVPSectionTitle}
                        {rsvpMandatory && allowRSVP && (
                          <span className="label-mandatory">*</span>
                        )}
                      </div>
                      <div className="custom-text-secondary-sm-medium">
                        {LocaleStrings.kSessionRSVPSectionDesc}
                      </div>
                    </div>
                    <dl className="base-form bg-white rounded-b-xl px-6 py-4">
                      {renderSessionRSVPValidation()}
                      <SessionRSVP
                        source="ticket"
                        ticketSessionSettings={ticketSessionSettings}
                        autofill={autofill}
                        formValues={formValues}
                        RSVPSessionsData={sessionRSVPPage}
                        eventSettingsData={eventSettingsData?.data}
                      />
                    </dl>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div
                  className={classNames(
                    allowPhoneSignup
                      ? "md:grid grid-cols-11 md:space-x-6 space-y-2 2xs:space-y-4 md:space-y-0"
                      : ""
                  )}
                >
                  <div className="md:col-span-5">
                    <Field
                      name={`email`}
                      label={LocaleStrings.kEmail}
                      placeholder={LocaleStrings.kEnterEmailAddress}
                      type="text"
                      component={renderFieldText}
                      mandatory={true}
                      onBlur={handleEmailCheck}
                    />
                  </div>
                  {allowPhoneSignup ? (
                    <>
                      <div className="md:col-span-1 md:pt-11 text-center">
                        {LocaleStrings.kOr}
                      </div>
                      <div className="md:col-span-5">
                        <Field
                          name={"phone"}
                          label={LocaleStrings.kPhoneNumber}
                          type={"number"}
                          component={RenderFieldPhone}
                          mandatory={true}
                          countrycode={countrycode}
                          countryList={countryList}
                          isrestricted={dropdowndisabled}
                          onBlur={handlePhoneCheck}
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
                {allowPhoneSignup ? (
                  <Field
                    name="registerwith"
                    type="text"
                    component={renderHiddenFieldText}
                  />
                ) : (
                  ""
                )}
              </>
            )}
          </>
        ) : (
          ""
        )}
      </>
    );
  };

  const renderSinglePageSections = () => {
    // console.log("allConditionalFields :- ", allConditionalFields);
    // console.log("sectionWiseArray :- ", sectionWiseArray);
    // console.log("lastFieldUpdated :- ", lastFieldUpdated);
    // console.log("formValues :- ", formValues);

    let renderFieldsArr = [];
    for (let pi = 0; pi < sectionWiseArray?.length; pi++) {
      let field = sectionWiseArray[pi];
      let name = field?.name;

      let ishidden = handleShowHide(
        name,
        formValues,
        props.autofill,
        lastFieldUpdated,
        allConditionalFields
        // sectionWiseArray
      );

      // console.log("section ishidden :- ", name, ishidden);
      // console.log("-------------------");

      if (ishidden === 0)
        renderFieldsArr.push(
          <SectionList
            key={name}
            source="ticketassign"
            section={field}
            autofill={props.autofill}
            formValues={formValues}
            tLastFieldUpdated={lastFieldUpdated}
            tAllConditionalFields={allConditionalFields}
            tsectionWiseArray={sectionWiseArray}
            updatedLastFieldChanged={updatedLastField}
          />
        );
    }

    // console.log("renderFieldsArr :- ", renderFieldsArr);
    return renderFieldsArr;
  };

  return (
    <>
      <li>
        {/* Header Box */}
        <div
          className={classNames(
            action === "refunded" ||
              _.isNil(assign?.ticketid) ||
              !allowReassign ||
              hideAssignDetails
              ? ""
              : "cursor-pointer",
            `py-4 px-4 flex items-center justify-between border-b ASSIGN_TICKETS_ITEM ASSIGN_TICKETS_ITEM_${ticketcode} ASSIGN_TICKETS_ITEM_POSITION_${position}`
          )}
          onClick={
            action === "refunded" || _.isNil(assign?.ticketid)
              ? null
              : handleAccordion
          }
        >
          <div
            className={`flex items-center space-x-2 ASSIGN_TICKETS_DETAILS ASSIGN_TICKETS_DETAILS_${ticketcode} ASSIGN_TICKETS_DETAILS_POSITION_${position}`}
          >
            <div
              className={`p-3 rounded-full bg-gray-200  ASSIGN_TICKETS_ICON ASSIGN_TICKETS_ICON_${ticketcode} ASSIGN_TICKETS_ICON_POSITION_${position}`}
              style={ticketColor ? { backgroundColor: ticketColor } : {}}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 8V7M10 12.5V11.5M10 17V16M5.2 4H18.8C19.9201 4 20.4802 4 20.908 4.21799C21.2843 4.40973 21.5903 4.71569 21.782 5.09202C22 5.51984 22 6.0799 22 7.2V8.5C20.067 8.5 18.5 10.067 18.5 12C18.5 13.933 20.067 15.5 22 15.5V16.8C22 17.9201 22 18.4802 21.782 18.908C21.5903 19.2843 21.2843 19.5903 20.908 19.782C20.4802 20 19.9201 20 18.8 20H5.2C4.0799 20 3.51984 20 3.09202 19.782C2.71569 19.5903 2.40973 19.2843 2.21799 18.908C2 18.4802 2 17.9201 2 16.8V15.5C3.933 15.5 5.5 13.933 5.5 12C5.5 10.067 3.933 8.5 2 8.5V7.2C2 6.0799 2 5.51984 2.21799 5.09202C2.40973 4.71569 2.71569 4.40973 3.09202 4.21799C3.51984 4 4.0799 4 5.2 4Z"
                  stroke="#FFFFFF"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <div>
              <div
                className={`flex items-center gap-1  ASSIGN_TICKETS_ACCORDIAN ASSIGN_TICKETS_TICKET_TAG_${ticketcode} ASSIGN_TICKETS_TICKET_TAG_POSITION_${position}`}
              >
                {ticketTag && (
                  <span
                    className="tickettag"
                    style={ticketColor ? { backgroundColor: ticketColor } : {}}
                  >
                    {ticketTag}
                  </span>
                )}
                {ticketGenre === "addon" && (
                  <span
                    className="ticketgenre"
                    yle={ticketColor ? { backgroundColor: ticketColor } : {}}
                  >
                    {LocaleStrings.kAddon}
                  </span>
                )}
              </div>
              <div
                className={`custom-text-primary-md-normal ASSIGN_TICKETS_TICKETNAME ASSIGN_TICKETS_TICKETNAME_${ticketcode} ASSIGN_TICKETS_TICKETNAME_POSITION_${position}`}
              >
                {assign?.ticketname}
              </div>
              {action === "reassign" ? (
                <div
                  className={`custom-text-secondary-sm-normal  ASSIGN_TICKETS_EMAIL ASSIGN_TICKETS_EMAIL_${ticketcode} ASSIGN_TICKETS_EMAIL_POSITION_${position}`}
                >
                  {assign?.regtype !== "nologinid"
                    ? assign?.regtype === "phone"
                      ? assign?.phone
                      : assign?.email
                    : ""}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          {!_.isNil(assign?.ticketid) && (
            <div
              className={`flex items-center space-x-6 ASSIGN_TICKETS_ACCORDIAN ASSIGN_TICKETS_ACCORDIAN_${ticketcode} ASSIGN_TICKETS_ACCORDIAN_POSITION_${position}`}
            >
              {action === "reassign" ? (
                <>
                  <div
                    className={`custom-text-primary-md-medium underline ASSIGN_TICKETS_VIEW_TICKET ASSIGN_TICKETS_VIEW_TICKET_${ticketcode} ASSIGN_TICKETS_VIEW_TICKET_POSITION_${position}`}
                    onClick={handleViewTicket}
                    style={hideAssignDetails ? { display: "none" } : {}}
                  >
                    {LocaleStrings.kViewTicketText}
                  </div>
                  {allowReassign ? (
                    <div
                      className={`custom-text-theme-md-medium underline ASSIGN_TICKETS_REASSIGN ASSIGN_TICKETS_REASSIGN_${ticketcode} ASSIGN_TICKETS_REASSIGN_POSITION_${position}`}
                      onClick={handleReassign}
                    >
                      {LocaleStrings.kReassignText}
                    </div>
                  ) : (
                    ""
                  )}
                </>
              ) : action === "assign" ? (
                <div
                  className={`custom-text-theme-md-medium ASSIGN_TICKETS_ASSIGN ASSIGN_TICKETS_ASSIGN_${ticketcode} ASSIGN_TICKETS_ASSIGN_POSITION_${position}`}
                >
                  {LocaleStrings.kAssignText}
                </div>
              ) : (
                ""
              )}
              {action === "refunded" ? (
                <div
                  className={`flex items-center space-x-1 ASSIGN_TICKETS_REFUND ASSIGN_TICKETS_REFUND_${ticketcode} ASSIGN_TICKETS_REFUND_POSITION_${position}`}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 10C2 10 4.00498 7.26822 5.63384 5.63824C7.26269 4.00827 9.5136 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.89691 21 4.43511 18.2543 3.35177 14.5M2 10V4M2 10H8"
                      stroke={"#EE7070"}
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                  <div className="custom-text-danger-md-normal">
                    {LocaleStrings.kRefundedText}
                  </div>
                </div>
              ) : (
                <div
                  style={
                    allowReassign || !hideAssignDetails
                      ? {}
                      : { display: "none" }
                  }
                >
                  {openContent ? (
                    <ChevronUpIcon className="w-5 h-5" />
                  ) : (
                    <ChevronDownIcon className="w-5 h-5" />
                  )}
                </div>
              )}
            </div>
          )}
        </div>

        {/* Content Box */}
        <div className={`${openContent ? "" : "hidden"}`}>
          {/* View section */}
          {displayBox === "view" && !hideAssignDetails ? (
            <>
              <div className="sm:grid sm:grid-cols-3 overflow-hidden">
                {/* User QR */}
                {ticketGenre !== "addon" && assign?.qrtoken ? (
                  <div
                    className={`flex items-center justify-center bg-default sm:col-span-1 px-4 py-4 QR_CODE  ASSIGN_TICKETS_QR_CODE ASSIGN_TICKETS_QR_CODE_${ticketcode} ASSIGN_TICKETS_QR_CODE_POSITION_${position}`}
                  >
                    <div className="p-4 overflow-hidden border border-default rounded-lg w-60 sm:w-full h-full bg-white">
                      <QRCode
                        size={215}
                        style={{ width: "100%", height: "100%" }}
                        viewBox={`0 0 256 256`}
                        value={assign?.qrtoken ?? ""}
                      />
                    </div>
                  </div>
                ) : (
                  ""
                )}

                {/* Other info */}
                <div
                  className={`bg-white ${
                    ticketGenre !== "addon" && assign?.qrtoken
                      ? "sm:col-span-2"
                      : "sm:col-span-3"
                  } px-4 py-4 ASSIGN_TICKETS_OTHER_INFO ASSIGN_TICKETS_OTHER_INFO_${ticketcode} ASSIGN_TICKETS_OTHER_INFO_POSITION_${position}`}
                >
                  <section aria-labelledby="information-heading">
                    <div
                      className={`xs:grid sm:block md:grid grid-cols-3 space-y-3 xs:space-y-0 sm:space-y-3 md:space-y-0 ASSIGN_TICKETS_ORDER_INFO ASSIGN_TICKETS_ORDER_INFO_${ticketcode} ASSIGN_TICKETS_ORDER_INFO_POSITION_${position}`}
                    >
                      <div
                        className={`col-span-2 ASSIGN_TICKETS_EVENT_AND_TICKET_INFO ASSIGN_TICKETS_EVENT_AND_TICKET_INFO_${ticketcode} ASSIGN_TICKETS_EVENT_AND_TICKET_INFO_POSITION_${position}`}
                      >
                        <div
                          className={`text-primary text-2xl font-bold ASSIGN_TICKETS_EVENT_NAME ASSIGN_TICKETS_EVENT_NAME_${ticketcode} ASSIGN_TICKETS_EVENT_NAME_POSITION_${position}`}
                        >
                          {eventData?.eventname}
                        </div>

                        <div
                          className={`mt-2 custom-text-primary-md-medium ASSIGN_TICKETS_TICKET_TYPE ASSIGN_TICKETS_TICKET_TYPE_${ticketcode} ASSIGN_TICKETS_TICKET_TYPE_POSITION_${position}`}
                        >
                          {LocaleStrings.kTicketType}
                        </div>
                        <div
                          className={`custom-text-secondary-md-normal ASSIGN_TICKETS_TICKET_NAME ASSIGN_TICKETS_TICKET_NAME_${ticketcode} ASSIGN_TICKETS_TICKET_NAME_POSITION_${position}`}
                        >
                          {assign?.ticketname}
                        </div>
                      </div>
                      <div
                        className={`col-span-1 ASSIGN_TICKETS_ORDER_NO ASSIGN_TICKETS_ORDER_NO_${ticketcode} ASSIGN_TICKETS_ORDER_NO_POSITION_${position}`}
                      >
                        <div className="w-fit rounded-full py-1 px-2 ring-1 ring-inset custom-text-theme-md-medium bg-gray-100 ring-gray-300/30">
                          {LocaleStrings.kOrderNoText} : {ordernumber}
                        </div>
                      </div>
                    </div>

                    {ticketGenre !== "addon" ? (
                      <>
                        {/* divider */}
                        <div
                          className={`relative py-5 ASSIGN_TICKETS_OTHER_INFO_DIVER ASSIGN_TICKETS_OTHER_INFO_DIVER_${ticketcode} ASSIGN_TICKETS_OTHER_INFO_DIVER_POSITION_${position}`}
                        >
                          <div
                            className="absolute inset-0 flex items-center"
                            aria-hidden="true"
                          >
                            <div className="w-full border-t border-gray-300" />
                          </div>
                        </div>
                        {/* divider */}

                        <div
                          className={`space-y-2 md:space-y-0 md:grid md:grid-cols-8 md:space-x-2 ASSIGN_TICKETS_ASSIGNED_INFO ASSIGN_TICKETS_ASSIGNED_INFO_${ticketcode}`}
                        >
                          <div
                            className={classNames(
                              `ASSIGN_TICKETS_ASSIGNED_USERNAME ASSIGN_TICKETS_ASSIGNED_USERNAME_${ticketcode} ASSIGN_TICKETS_ASSIGNED_USERNAME_POSITION_${position}`,
                              assign?.regtype !== "nologinid"
                                ? "col-span-3"
                                : "col-span-8"
                            )}
                          >
                            <div className="custom-text-primary-md-medium">
                              {LocaleStrings.kAttendeeNameText}
                            </div>
                            <div className="custom-text-secondary-md-medium break-words">
                              {assign?.firstname ?? "-"}{" "}
                              {assign?.lastname ?? "-"}
                            </div>
                          </div>

                          {assign?.regtype !== "nologinid" ? (
                            <>
                              <div
                                className={`col-span-3 ASSIGN_TICKETS_ASSIGNED_EMAIL ASSIGN_TICKETS_ASSIGNED_EMAIL_${ticketcode} ASSIGN_TICKETS_ASSIGNED_EMAIL_POSITION_${position}`}
                              >
                                <div className="custom-text-primary-md-medium">
                                  {assign?.regtype === "phone"
                                    ? LocaleStrings.kPhoneNumber
                                    : LocaleStrings.kEmail}
                                </div>
                                <div className="custom-text-secondary-md-medium break-all">
                                  {assign?.regtype === "phone"
                                    ? assign?.phone ?? "-"
                                    : assign?.email ?? "-"}
                                </div>
                              </div>
                              <div
                                className={`col-span-2 ASSIGN_TICKETS_ASSIGNED_PASSCODE ASSIGN_TICKETS_ASSIGNED_PASSCODE_${ticketcode} ASSIGN_TICKETS_ASSIGNED_PASSCODE_POSITION_${position}`}
                              >
                                <div className="custom-text-primary-md-medium">
                                  {LocaleStrings.kLabelPasscode}
                                </div>
                                <div className="custom-text-secondary-md-medium break-all">
                                  {assign?.passcode ? (
                                    <div
                                      className={classNames(
                                        displayPasscode
                                          ? "space-x-2.5-"
                                          : "space-x-4-",
                                        "custom-item-vcenter relative"
                                      )}
                                    >
                                      {displayPasscode ? (
                                        <span>{assign?.passcode}</span>
                                      ) : (
                                        <span className="">******</span>
                                      )}

                                      {displayPasscode ? (
                                        <EyeIcon
                                          className="w-5 h-5 cursor-pointer absolute left-16"
                                          onClick={() =>
                                            handlePasscodeDisplay("hide")
                                          }
                                        />
                                      ) : (
                                        <EyeSlashIcon
                                          className="w-5 h-5 cursor-pointer absolute left-16"
                                          onClick={() =>
                                            handlePasscodeDisplay("display")
                                          }
                                        />
                                      )}
                                    </div>
                                  ) : (
                                    " - "
                                  )}
                                </div>
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                        </div>

                        <div className="flex items-center justify-between py-5 border-t mt-6 gap-2 app-login-button-section APP_LOGIN_BUTTON_SECTION">
                          <div
                            className={classNames(
                              assign?.regtype !== "nologinid"
                                ? "space-y-2 md:space-y-0 md:grid md:grid-cols-2"
                                : "flex items-center gap-2",
                              "app-stores-buttons APP_STORE_BUTTONS"
                            )}
                          >
                            <img
                              className="col-span-1 cursor-pointer APPSTORE_IMAGE"
                              src={AppStore}
                              alt="AppStore"
                              onClick={() => handleApp("ios")}
                            />
                            <img
                              className="col-span-1 cursor-pointer PLAYSTORE_IMAGE"
                              src={GooglePlay}
                              alt="GooglePlay"
                              onClick={() => handleApp("android")}
                            />
                          </div>
                          {assign?.regtype !== "nologinid" ? (
                            <div className="web-login-buttons WEB_LOGIN_BUTTONS">
                              <button
                                className="theme-button-md LOGIN_BUTTON"
                                onClick={openWebPortel}
                              >
                                {LocaleStrings.kLoginPortalText}
                              </button>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </section>
                </div>
              </div>
            </>
          ) : (
            <>
              {/* Form section */}
              {action === "reassign" && !allowReassign ? (
                ""
              ) : (
                <div className="bg-default px-4 py-4">
                  {/* Dispaly error, if any */}
                  {orderErrorMessage !== "" ? (
                    <div ref={alertRef}>
                      <div className="rounded-md bg-red-50 border border-red-200 p-4 mb-4">
                        <div className="flex">
                          <p className="text-base font-normal text-customred">
                            {orderErrorMessage}
                          </p>

                          <div className="ml-auto pl-3">
                            <div className="-mx-1.5 -my-1.5">
                              <button
                                type="button"
                                className="inline-flex rounded-md bg-red-50 p-1.5 text-red-600 hover:bg-red-100 focus:outline-none"
                                onClick={closeAlert}
                              >
                                <span className="sr-only">Dismiss</span>
                                <XMarkIcon
                                  className="h-5 w-5"
                                  aria-hidden="true"
                                />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  <form onSubmit={handleSubmit(onSubmitForm)}>
                    <div className="base-form">
                      {renderFixedFields(ticketGenre, assignformdisplay)}
                    </div>

                    <div className="mt-4 text-right">
                      <button
                        type="submit"
                        className="theme-button-md"
                        disabled={pristine || invalid || submitting || loading}
                      >
                        <svg
                          className={classNames(
                            loading ? "" : "hidden",
                            "cust-btn-spinner"
                          )}
                          viewBox="0 0 1024 1024"
                          focusable="false"
                          data-icon="btnloading"
                          width="1em"
                          height="1em"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
                        </svg>{" "}
                        {action === "reassign"
                          ? LocaleStrings.kReassignText
                          : LocaleStrings.kAssignText}
                      </button>
                    </div>
                  </form>
                </div>
              )}
            </>
          )}
        </div>
      </li>
    </>
  );
};

const validate = (values, ownProps) => {
  let eventUserCategories = ownProps?.eventUserCategories?.data ?? []; // Event user categories
  let eventCustomSettings = ownProps?.eventCustomSettings ?? {};
  let assign = ownProps?.assign;
  let eventData = ownProps?.eventData;

  let usercategory = assign?.usercategory;
  let sessionRSVPPage = assign?.rsvpsessions ?? [];
  let allowPhoneSignup = assign?.allowphonelogin ?? false; // Dynamic form phone login
  let emailOptional = assign?.emailoptional ?? false; // Dynamic form email is optional setting, Validate email field as per setting
  let rsvpMandatory = eventCustomSettings?.rsvp_mandatory ?? false;
  let ticketSessionSettings = {};
  if (sessionRSVPPage?.length > 0) {
    let ticket = assign;
    // Check for ticket session rsvp related setting
    ticketSessionSettings = sessionRSVPAllowed(
      ticket,
      eventData?.eventtimezone
    );
  }
  let allowRSVP = ticketSessionSettings?.allowrsvp ?? true; // Session RSVP restriction

  let errors = {};
  let email = values?.email ?? null;
  let phone = values?.phone ?? null;
  // console.log({ email, phone });

  if (allowPhoneSignup) {
    if ((!phone || phone.trim() === "") && (!email || email.trim() === "")) {
      // errors["registerwith"] = LocaleStrings.kRegistrationWithRequired;
      errors["phone"] = LocaleStrings.kRegistrationWithRequired;
      if (!emailOptional) {
        errors["email"] = LocaleStrings.kRegistrationWithRequired;
      }
    } else {
      if (phone) {
        phone = phone.trim();
        if (!validatePhoneNumbers(phone) || phone.length < 10) {
          errors["phone"] = LocaleStrings.kInvalidPhoneText;
        }
      }
      if (email) {
        email = email.trim();
        if (!validateEmail(email)) {
          errors["email"] = LocaleStrings.kInvalidEmail;
        }
      }
    }
  } else {
    if (emailOptional) {
      if (email && email.trim() !== "") {
        email = email.trim();
        if (!validateEmail(email)) {
          errors["email"] = LocaleStrings.kInvalidEmail;
        }
      }
    } else {
      if (!email || email.trim() === "") {
        errors["email"] = LocaleStrings.kFieldRequired;
      } else {
        email = email.trim();
        if (!validateEmail(email)) {
          errors["email"] = LocaleStrings.kInvalidEmail;
        }
      }
    }
  }
  // console.log({ email, phone });

  if (email && validateEmail(email)) {
    // Logic to validate email domain which are whitelisted
    let tCategory = usercategory;

    let check = _.filter(
      eventUserCategories,
      (o) =>
        parseInt(o.id) === parseInt(tCategory) &&
        o?.allowemaildomain &&
        o?.allowemaildomain !== ""
    );
    let allowedEmailDomain =
      check?.length > 0 ? check[0].allowemaildomain.trim() : "";
    // console.log("allowedEmailDomain :- ", allowedEmailDomain);

    if (!validateEmailDomain(allowedEmailDomain, email)) {
      let emailDomain = email?.split("@")?.[1];
      errors["email"] = _.replace(
        LocaleStrings.kInvalidEmailDomainText,
        "###DOMAIN###",
        emailDomain
      );
    }
  }

  if (sessionRSVPPage?.length > 0 && rsvpMandatory && allowRSVP) {
    let rsvpsessions = values?.rsvpsessions ?? [];
    if (rsvpsessions?.length === 0) {
      errors["rsvpsessionserror"] = LocaleStrings.kFieldRequired;
    }
  }

  if (assign?.ticketgenre !== "addon") {
    let firstname = values[`firstname`];
    let lastname = values[`lastname`];

    if (!firstname || firstname.trim() === "") {
      errors[`firstname`] = LocaleStrings.kFieldRequired;
    }
    if (!lastname || lastname.trim() === "") {
      errors[`lastname`] = LocaleStrings.kFieldRequired;
    }

    if (assign?.assignformdisplay === "long") {
      let formArray = [];
      if (ownProps?.eventUserCategories?.data) {
        let matchCat = _.filter(ownProps?.eventUserCategories?.data, (obj) => {
          return obj.id === ownProps?.assign?.usercategory;
        });
        formArray =
          matchCat?.length > 0 ? JSON.parse(matchCat?.[0]?.formjson) : [];
      }

      _.map(formArray, (form, index) => {
        let key = form?.key;
        let name = form?.name;
        let isReadOnly = form?.isreadonly ?? false;
        let isHidden = form?.hidden ?? false;
        let fieldtype = form?.fieldtype;
        let isRequired =
          form?.required && !isReadOnly && !isHidden ? true : false;
        let isExclude = form?.exclude ?? false;

        let relatedWith = [];
        allConditionalFields.forEach((item) => {
          let fName = item.name;
          let fKey = item.key;
          let options = item.options;
          let check = _.filter(options, (val) => {
            return val?.displayfields.indexOf(name) > -1;
          });
          // console.log("check :- ", name, check);

          if (check.length > 0) {
            let val = [];
            check.forEach((v) => {
              val.push(v?.value);
            });

            relatedWith.push({
              key: fKey,
              name: fName,
              value: val,
            });
          }
        });
        // console.log(name, relatedWith);

        if (!isExclude) {
          if (isRequired && !values[name]) {
            // Check either this filed linked with other fields or not
            if (relatedWith.length > 0) {
              let match = [];
              _.map(relatedWith, (rel) => {
                if (values[rel?.name]) {
                  // console.log("option val :- ", values[rel?.name]);
                  if (rel?.key === "checkboxes") {
                    let common = _.intersection(values[rel?.name], rel?.value);
                    match = _.concat(match, common);
                  } else {
                    let common = _.filter(
                      rel?.value,
                      (o) => o === values[rel?.name]
                    );
                    match = _.concat(match, common);
                  }
                }
              });
              // console.log("match :- ", name, match);
              if (match.length > 0) {
                // console.log(name, "Required...........................");
                errors[name] = LocaleStrings.kFieldRequired;
              }
            } else {
              errors[name] = LocaleStrings.kFieldRequired;
            }
          } else if (isRequired && values[name]) {
            let valueType = typeof values[name];
            // console.log("valueType :- ", valueType);

            if (key !== "datepicker" && valueType !== "boolean") {
              if (valueType === "string" && values[name].trim() === "") {
                errors[name] = LocaleStrings.kFieldRequired;
              } else if (_.isEmpty(values[name])) {
                errors[name] = LocaleStrings.kFieldRequired;
              }
            }
          }
          if (
            (name === "facebook" ||
              name === "twitter" ||
              name === "linkedin" ||
              fieldtype === "facebook" ||
              fieldtype === "twitter" ||
              fieldtype === "linkedin") &&
            values[name] &&
            !validateUrl(values[name])
          ) {
            errors[name] =
              name === "facebook" || fieldtype === "facebook"
                ? LocaleStrings.kInvalidFacebookLinkText
                : name === "twitter" || fieldtype === "twitter"
                ? LocaleStrings.kInvalidTwitterLinkText
                : name === "linkedin" || fieldtype === "linkedin"
                ? LocaleStrings.kInvalidLinkedinLinkText
                : LocaleStrings.kInvalidUrlText;
          }
          // if (
          //   (name === "isnetworking" || name === "termsconditions") &&
          //   !values[name]
          // ) {
          //   errors[name] = LocaleStrings.kFieldRequired;
          // }
          if (
            form?.maxlen &&
            values?.[name] &&
            values?.[name]?.length > form?.maxlen
          ) {
            errors[name] = `${_.replace(
              LocaleStrings.kTextMaxLengthText,
              "#maxlength",
              form?.maxlen
            )}`;
          }
          if (
            (name === "phonenumber" ||
              fieldtype === "phonenumber" ||
              fieldtype === "whatsapp" ||
              name === "whatsapp") &&
            values?.[name] &&
            !validatePhoneNumbers(values?.[name])
          ) {
            errors[name] = LocaleStrings.kInvalidPhoneText;
          }
        }
      });
    }
  }

  // console.log("errors :- ", errors);
  return errors;
};

const mapStateToProps = (state, ownProps) => {
  // console.log("------------", ownProps.assign);
  let assign = ownProps?.assign;
  let ticketGenre = assign?.ticketgenre;
  let eventCustomSettings = JSON.parse(
    state?.eventSettingsData?.data?.custom_settings ?? "{}"
  );
  const allowPhoneSignup = assign?.allowphonelogin ?? false; // Dynamic form phone login

  let init =
    ticketGenre !== "addon"
      ? { isnetworking: false, termsconditions: false }
      : {};

  if (assign?.action === "reassign" && assign?.appuserid) {
    init.email = assign?.email;
    if (allowPhoneSignup) {
      init.phone = assign?.phone ?? null;
    }

    if (ticketGenre !== "addon") {
      init.firstname = assign?.firstname;
      init.lastname = assign?.lastname;
      init.interest = assign?.interest;

      let formArray = JSON.parse(assign?.responses ?? []);
      _.forEach(formArray, (obj) => {
        let formKey = obj.key;
        let name = obj.name;
        let savedValue = obj?.value ?? "";
        if (formKey === "checkboxes" || formKey === "file") {
          savedValue = obj?.value ?? [];
        }

        if (
          formKey !== "label" &&
          formKey !== "hyperlink" &&
          formKey !== "paragraph" &&
          formKey !== "section"
        ) {
          if (formKey === "datepicker") {
            let date = "";
            if (savedValue && savedValue !== "") {
              if (savedValue && obj?.pickertype == "range") {
                savedValue = _.isString(savedValue)
                  ? savedValue.split(" - ")
                  : [];
                date = savedValue
                  ?.map((d) => {
                    if (typeof d === "string" && checkDateFormatYMD(d)) {
                      return moment(new Date(Date.parse(d)))?.format(
                        DATE_FORMAT
                      );
                    } else {
                      return moment(d, DISPLAY_BROWSER_DATE_FORMAT)?.format(
                        DATE_FORMAT
                      );
                    }
                  })
                  .filter((d) => moment(d)?.isValid()); // Filter out invalid dates
                date = date?.join(" - ");
              } else {
                if (savedValue && typeof savedValue === "string") {
                  if (checkDateFormatYMD(savedValue)) {
                    let dateParse = new Date(Date.parse(savedValue));
                    date = moment(dateParse).format(DATE_FORMAT);
                  } else {
                    date = moment(
                      savedValue,
                      DISPLAY_BROWSER_DATE_FORMAT
                    ).format(DATE_FORMAT);
                  }
                  if (!moment(date).isValid()) {
                    date = "";
                  }
                } else {
                  date = moment(savedValue).format(DATE_FORMAT);
                }
              }
            }

            init[name] = date;
          } else if (formKey === "dropdown") {
            let checkType = typeof savedValue;
            let val = "";
            if (checkType === "object") {
              val = savedValue?.value ?? "";
            } else {
              val = savedValue ?? "";
            }
            init[name] = val;
          } else if (formKey === "dynamicfield" && name === "interest") {
            // No value need to store here.
          } else {
            if (formKey === "checkboxes") {
              init[name] = savedValue;
            } else if (formKey === "file") {
              let filesArr = [];
              _.forEach(savedValue, (item) => {
                let f1 = item.split("/").pop();
                let f2 = f1.split("_");
                f2.shift();

                let fileName = f2.join("_");
                filesArr.push({ file: item, filename: fileName });
              });
              init[name] = filesArr;
            } else {
              init[name] = savedValue;
            }
          }
        }
      });

      let rsvpSessions = assign?.rsvpsessions;
      if (rsvpSessions?.length > 0) {
        let userRSVPSessions = assign?.userrsvpsessions;
        let selectedSessions = [];
        let markedSessions = [];
        _.map(rsvpSessions, (ses) => {
          let sesid = ses?.sessionid;
          let index = _.includes(userRSVPSessions, sesid);
          if (index) {
            markedSessions.push(true);
            selectedSessions.push(sesid);
          } else {
            markedSessions.push(false);
          }
        });
        init.rsvpsessions = selectedSessions;
        init.markrsvp = markedSessions;
      }
    }
  }
  // console.log("init :- ", init);

  return {
    session: state.session,
    initialValues: init,
    eventData: state.eventData,
    eventSettingsData: state.eventSettingsData,
    eventCustomSettings,
    orderData: state.orderData,
    eventUserCategories: state.eventUserCategories,
    countryList: state.countryList,

    formValues: getFormValues(ownProps.form)(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { validateAssignedEmail, ticketAssignReassign, fetchSingleOrder },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    validate,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(TicketAssign)
);
